import Axios from 'axios';
import alert from '../util/alert'
import {AUTH_LOGOUT} from "../store/actions/auth";
import store from '../store';
import {Errors} from "../constants";
import {AUTH_TOKEN} from "../util/constants";
import Approuter from '../router'
import {PAGE_LOADED} from "../store/actions/page";

function handleSessionExpiration(err) {
    let errorMsg = (err.response && err.response.data) ? err.response.data.message : Errors.SERVER_ERROR;
    if (!err.response) {
        errorMsg = Errors.SERVER_UNAVAILABLE;
        alert.error(null, Errors.SERVER_UNAVAILABLE);
    } else if (err.response.status === 403 || err.response.status === 401) {
        store.dispatch(AUTH_LOGOUT);
        Approuter.router.push({name: 'login'})
    }
    store.dispatch(PAGE_LOADED)
    throw errorMsg;
}

const putAuthorization = async (conf) => {
    try {
        const token = localStorage.getItem(AUTH_TOKEN);
        if (token) {
            if (!conf) {
                conf = {};
            }
            if (!conf.headers) {
                conf.headers = {};
            }
            conf.headers['Authorization'] = `Bearer ${token}`;
        }

    } catch (e) {
        console.error(e);
    }
    return conf;
};

export default {
    init() {
        Axios.defaults.baseURL = process.env.SVC_URL;
    },
    async get(url, conf = {}) {
        conf = await putAuthorization(conf);
        return Axios.get(url, conf)
            .catch((err) => {
                handleSessionExpiration(err);
                throw err;
            })
    },
    async post(url, data, conf = {}) {
        conf = await putAuthorization(conf);
        return Axios.post(url, data, conf)
            .catch((err) => {
                handleSessionExpiration(err);
                throw err;
            });
    },
    async put(url, data, conf = {}) {
        conf = await putAuthorization(conf);
        return Axios.put(url, data, conf).catch((err) => {
            handleSessionExpiration(err);
            throw err;
        });
    },
    patch(url, data, conf = {}) {
        return putAuthorization(conf, () => {
            return Axios.patch(url, data, conf)
                .catch((err) => {
                    handleSessionExpiration(err);
                    throw err;
                });
        })
    },
    async delete(url, conf = {}) {
        conf = await putAuthorization(conf);
        return Axios.delete(url, conf).catch((err) => {
            handleSessionExpiration(err);
            throw err;
        });
    },
}



// WEBPACK FOOTER //
// ./src/services/rest.js